export const links = [
  {
    url: '/play-with-coins',
    name: 'Games',
  },
  {
    url: '/',
    name: 'Home',
  },
  // {
  //   url: '/account',
  //   name: 'Account',
  // },
];
